export const reviews = [
    {
        author: 'Lucy Mitchell',
        reviewerDetail: 'Director of Corporate Communications, and Investor Relations',
        description: '“The Completely Retail team are superb and a pleasure to work with. The creative studio are particularly noteworthy - their deep knowledge of real estate helps us create slick marketing materials - the team are pro-active, flexible and always prompt on communications and design turnarounds.”',
        logo: 'sales/NewRiver.png',
        company: 'NewRiver'
    },
    {
        author: 'Adam Stone',
        reviewerDetail: 'Director',
        description: '“The convenience of advertising and managing our marketing material on the Completely Retail’s platform across our extensive portfolio has saved us a significant amount of time and effort over the years. The team are always on call to ensure our data and marketing collateral is always up-to-date, visually appealing, and tailored to resonate with the right tenants."',
        logo: 'sales/nuveen.png',
        company: 'nuveen'
    },
    {
        author: 'John Duxbury',
        reviewerDetail: 'Head of UK Portfolio Asset Management',
        description: '"We’ve sponsored our UK retail and leisure schemes on Completely Retail for over 10 years. As a company managing a diverse range of assets, keeping track of leasing activities and effectively marketing our shopping centres and retail parks is important to driving performance for our clients and, for responding to requirements of our occupier customers. Completely Retail’s user-friendly site allows us to seamlessly manage the online marketing of our assets alongside production of associated marketing materials. In an ever-changing landscape, Completely Retail continues to be a valuable partner in our success.”',
        logo:  'sales/m&g.png',
        company: 'm&g'
    }
];